module.exports = __webpack_public_path__ + "static/media/pipesImage.730f2acc.jpg";